import * as React from "react";
import Button from "./Button";

interface IProps {
  title: React.ReactNode;
  open: boolean;
  close?: () => void;
  closable?: boolean;
  submitText?: React.ReactNode;
  onSubmit?: () => void;
  children: React.ReactNode;
  isLarge?: boolean;
  submittable?: boolean;
  onClose?: () => void;
  isSubmitting?: boolean;
  closeText?: string;
  canClose?: boolean;
  canSubmit?: boolean;
  disallowClickOutside?: boolean;
  hideCloseX?: boolean;
}

class Modal extends React.Component<IProps> {
  _modalRef: HTMLDivElement;

  // jQuery DOM ref
  modalNode: any;

  componentDidMount() {
    const { open, disallowClickOutside } = this.props;

    this.modalNode = $(this._modalRef);

    this.modalNode.modal({
      show: open,
      backdrop: disallowClickOutside ? "static" : undefined,
    });
  }

  componentDidUpdate(prevProps) {
    const { open, onClose } = this.props;
    this.modalNode.modal(open ? "show" : "hide");
    const prevOpen = prevProps.open;
    if (onClose && prevOpen && !open) {
      onClose();
    }
  }

  render() {
    const {
      close = () => {},
      closable = true,
      title,
      onSubmit = () => {},
      submitText = "Submit",
      children,
      isLarge = false,
      submittable = true,
      isSubmitting = false,
      closeText = "Close",
      canClose = true,
      hideCloseX = false,
      canSubmit = true,
    } = this.props;

    let additionalDialogClasses = "";

    if (isLarge) {
      additionalDialogClasses += "modal-lg";
    }

    return (
      <div
        className="modal fade"
        tabIndex={-1}
        role="dialog"
        ref={c => (c ? (this._modalRef = c) : null)}
      >
        <div
          className={`modal-dialog ${additionalDialogClasses}`}
          role="document"
        >
          <div className="modal-content">
            <div className="modal-header">
              {closable && !hideCloseX && (
                <button
                  type="button"
                  className="close"
                  aria-label="Close"
                  onClick={close}
                  disabled={!canClose}
                >
                  <span aria-hidden="true">×</span>
                </button>
              )}
              <h4 className="modal-title">{title}</h4>
            </div>
            <div className="modal-body">{children}</div>
            <div className="modal-footer">
              {closable && (
                <button
                  type="button"
                  className="btn btn-default"
                  onClick={close}
                  disabled={!canClose}
                >
                  {closeText}
                </button>
              )}
              {submittable && (
                <Button
                  type="button"
                  className="btn btn-primary"
                  onClick={onSubmit}
                  loading={isSubmitting}
                  disabled={!canSubmit}
                >
                  {submitText}
                </Button>
              )}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Modal;



// WEBPACK FOOTER //
// ./app/javascript/components/core/Modal.tsx